import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  getBookingDetails,
  setBookingStatus,
} from "../../../../actions/admin/scheduled-event-actions";
import { Modal, ModalBody } from "reactstrap";
import Loader from "../../../../components/Loader/Loader";
import { FRONTEND_BASE_URL } from "../../../../utils/utility";
import {
  notification,
  onModalOpen,
  onModalClose,
} from "../../../../utils/utility";
import { formatBookingDate } from "./formatBookingDate";
import "./scheduledEvents.scss";

const DetailItem = ({ label, value, wide = false }) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return null;
  }
  return (
    <div className={`se-details__item${wide ? " se-details__item--wide" : ""}`}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
};

const PastViewDetails = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState(null);
  const [noShowModal, setNoShowModal] = useState(false);
  const toggleNoShowModal = () => {
    if (!noShowModal) {
      onModalOpen();
    } else {
      onModalClose();
    }
    setNoShowModal(!noShowModal);
  };

  useEffect(() => {
    const { getBookingDetails, bookingId } = props;
    setIsLoading(true);
    getBookingDetails({
      data: {
        id: bookingId,
      },
      onSuccess: function (response) {
        setData(response);
        setIsLoading(false);
      },
      onError: function (error) {
        console.error(error);
        setIsLoading(false);
      },
    });
  }, []);

  /**
   * on copy event link
   * @param {*} eventURL
   */
  const onCopyEventLink = (eventURL) => {
    var tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = FRONTEND_BASE_URL + "booking/" + eventURL;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
    notification.success(
      `Event URL Copied ${FRONTEND_BASE_URL}booking/${eventURL}`
    );
    document.body.removeChild(tempInput);
  };

  /**
   * on mark as no show
   */
  const setStatus = (status) => {
    const { id } = data;
    const { setBookingStatus, updatePastEventStatus } = props;
    setIsLoading(true);
    setBookingStatus({
      data: {
        id: id,
        status,
      },
      onSuccess: function (response) {
        if (status === "MN") {
          toggleNoShowModal();
        }
        const appliedStatus = response?.status || status;
        setData({
          ...data,
          booking_status: appliedStatus,
        });
        if (typeof updatePastEventStatus === "function") {
          updatePastEventStatus(id, appliedStatus);
        }
        notification.success("Status Successfully updated");

        setIsLoading(false);
      },
      onError: function (error) {
        console.error(error);
        setIsLoading(false);
      },
    });
  };

  const whenLabel = data
    ? [
        formatBookingDate(data.when, "DD-MM-YYYY"),
        data.start_time && data.end_time
          ? `${data.start_time} – ${data.end_time}`
          : null,
        data.host_timezone ? `(${data.host_timezone})` : null,
      ]
        .filter(Boolean)
        .join(" ")
    : "";

  return (
    <>
      <Loader isShowLoader={isLoading} />
      <Modal
        returnFocusAfterClose
        isOpen={props.showViewDetailModal && !isLoading}
        toggle={props.handleClose}
        centered
        className="se-details-modal"
        contentClassName="se-details-modal__content"
      >
        <ModalBody>
          {data ? (
            <div className="se-details">
              <header className="se-details__header">
                <div className="se-details__header-copy">
                  <p className="se-details__eyebrow">Booking details</p>
                  <h2>{data.event_name}</h2>
                  {data.start_time && data.end_time ? (
                    <span className="se-details__slot">
                      {data.start_time} – {data.end_time}
                    </span>
                  ) : null}
                </div>
                <button
                  type="button"
                  className="se-details__close"
                  onClick={props.handleClose}
                  aria-label="Close"
                >
                  ×
                </button>
              </header>

              <dl className="se-details__grid">
                <DetailItem label="When" value={whenLabel} wide />
                <DetailItem label="Host" value={data.host} />
                <DetailItem label="Invitee" value={data.invitee} />
                <DetailItem label="Duration" value={data.event_duration} />
                <DetailItem label="Invitee time zone" value={data.invitee_timezone} />
                <DetailItem label="Venue" value={data.venue} />
                <DetailItem
                  label="Venue details"
                  value={data.venue_details}
                  wide
                />
                <DetailItem
                  label="Invitee instructions"
                  value={data.customer_instruction}
                  wide
                />
                <DetailItem
                  label="Invitee feedback"
                  value={data.message_from_customer}
                  wide
                />
                {(data.question_details || []).map((questionDetail, index) => (
                  <DetailItem
                    key={`questions-${index}`}
                    label={questionDetail.question || "Question"}
                    value={questionDetail.answer}
                    wide
                  />
                ))}
              </dl>

              <div className="se-details__actions">
                {data.booking_status === "MN" ? (
                  <button
                    type="button"
                    className="se-btn se-btn--ghost"
                    onClick={() => setStatus("CO")}
                  >
                    Undo mark as no-show
                  </button>
                ) : (
                  <button
                    type="button"
                    className="se-btn se-btn--ghost"
                    onClick={toggleNoShowModal}
                  >
                    Mark as no-show
                  </button>
                )}
                {data.event_url ? (
                  <button
                    type="button"
                    className="se-btn se-btn--ghost"
                    onClick={() => onCopyEventLink(data.event_url)}
                  >
                    Copy event link
                  </button>
                ) : null}
              </div>
            </div>
          ) : null}
        </ModalBody>
      </Modal>

      <Modal
        className="se-details-modal"
        contentClassName="se-details-modal__content"
        centered
        isOpen={noShowModal}
        toggle={toggleNoShowModal}
      >
        <ModalBody>
          <div className="se-details">
            <header className="se-details__header">
              <div className="se-details__header-copy">
                <p className="se-details__eyebrow">No-show</p>
                <h2>Mark this event as a no-show?</h2>
              </div>
              <button
                type="button"
                className="se-details__close"
                onClick={toggleNoShowModal}
                aria-label="Close"
              >
                ×
              </button>
            </header>
            <p className="se-confirm__copy">
              This will prevent your invitee from receiving any automated
              follow-up messages after the event.
            </p>
            <div className="se-details__actions">
              <button
                type="button"
                className="se-btn se-btn--ghost"
                onClick={toggleNoShowModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="se-btn se-btn--primary"
                onClick={() => setStatus("MN")}
              >
                Mark as no-show
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default connect(null, {
  getBookingDetails,
  setBookingStatus,
})(PastViewDetails);
